import { companyPartnerIntegrationsService, IntegrationType } from '@aslanpay/portal-common-lib';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface AddIntegrationTypeParams {
  id: string;
  companyId: string;
  integrationType: IntegrationType;
  // Merged into the connection's config before the type is enabled - lets the type's required config
  // fields (e.g. Cezanne's deductionCode) be set in this same call.
  config?: Record<string, string>;
}

const useAddIntegrationType = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, integrationType, config }: AddIntegrationTypeParams) =>
      companyPartnerIntegrationsService.addType(id, { integrationType, config }),
    onSuccess: (_, { companyId }) => {
      queryClient.invalidateQueries({ queryKey: ['fetchCompanyIntegrations', companyId] });
    },
  });
};

export default useAddIntegrationType;
